// Decibel Hair - Store-specific JavaScript

if (document.body.classList.contains("customer--pro")) {

  console.error("Pro has been detected");

  const PRICE_SELECTOR = ".plp-card__current-price, .js-price-update, .js-selling-plan-price, .fbt-price-display";
  const EXCLUDED_PRODUCT_ID = "7538974031985";

  function isExcludedPrice(el) {
    // PLP: data-product-id is on the image link, not an ancestor of the price
    if (el.closest(`.plp-card--${EXCLUDED_PRODUCT_ID}`)) return true;
    // PDP / FBT: price sits inside (or is) the data-product-id element
    if (el.closest(`[data-product-id="${EXCLUDED_PRODUCT_ID}"]`)) return true;
    return false;
  }

  function halvePrice(el) {
    if (isExcludedPrice(el)) return;

    const raw = el.textContent?.replace(/[^0-9.]/g, "") ?? "";
    const price = parseFloat(raw);
    if (isNaN(price) || price === 0) return;

    const symbol = el.textContent?.match(/[^\d.,\s]/)?.[0] ?? "$";
    const halved = (price / 2).toFixed(2);
    el.textContent = `${symbol}${halved}`;
    el.setAttribute("content", String(parseFloat(halved)));
  }

  document.querySelectorAll(PRICE_SELECTOR).forEach(halvePrice);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      const target = mutation.target;
      if (target.nodeType === Node.ELEMENT_NODE && target.matches?.(PRICE_SELECTOR)) {
        observer.disconnect();
        halvePrice(target);
        observe();
      }
    }
  });

  function observe() {
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  observe();
}
else {
    console.error("Pro has NOT been detected");
}
